import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { store } from './Store/store';
import Spinner from './Components/Spinner';
import AuthenticatedApp from './AuthenticatedApp';
import isAuth from './Utils/auth';
import { Waiting, WaitingContainer } from './Utils/styleConstants';

const App = () => {
    const [authData, setAuthData] = useState(null);
    const [apiError, setApiError] = useState(false);

    useEffect(() => {
        isAuth()
            .then(authData => setAuthData(authData))
            .catch(() => {
                console.error('Unable to auth');
                setApiError(true);
            });
    }, [])

    return (
        (authData && authData.logged) ? (
            <Provider store={store}>
                <AuthenticatedApp { ...authData.token } />
            </Provider>
        ) : (
            <WaitingContainer>
                {
                    apiError ? (
                        <>
                            <Waiting>Oups, impossible de se connecter.</Waiting>
                            <Waiting>:(</Waiting>
                        </>
                    ) : (
                        <>
                            <Waiting>Connexion en cours, patientez ...</Waiting>
                            <Spinner size={150} />
                        </>
                    )
                }
            </WaitingContainer>
        )
    );
};

export default App;
